export default {
  en: {
    no_assignees: 'No members assigned',
    assignees: {
      zero: 'Assign now!',
      one: '1 member assigned',
      other: '%{count} members assigned',
    },
    closed: 'Assigning is closed',
  },
};
